import {
  CreatePlaidTokenRequest,
  CreatePlaidTokenResponse,
  PlaidTokenRequestParameters,
  PlaidTokenResponse,
} from 'models/Plaid'

import { api, usePrefetchNow } from '../api'

const plaidApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // This isn't really a token, but naming convention from classypay is followed
    // it returns merchant account info
    getPlaidToken: builder.query<PlaidTokenResponse, PlaidTokenRequestParameters>({
      query: ({ campaignId, currency }) => ({
        url: `/token/plaid?campaignId=${campaignId}&currency=${currency}`,
      }),
    }),
    createLinkToken: builder.mutation<CreatePlaidTokenResponse, CreatePlaidTokenRequest>({
      query: ({ memberId }) => ({
        url: '/token/plaidLinkToken',
        method: 'POST',
        body: { memberId },
      }),
    }),
  }),
})

export const usePrefetchPlaidToken = (campaignId: string, currency: string) =>
  usePrefetchNow(
    plaidApi.endpoints.getPlaidToken,
    { campaignId, currency },
    !!campaignId && !!currency,
  )

export default plaidApi
